import type { ReactNode } from 'react';
import { cn } from '../lib/cn';

type Tone = 'info' | 'success' | 'warning' | 'danger';

const TONES: Record<Tone, string> = {
  info: 'bg-brand-50 text-brand-700 border-brand-200',
  success: 'bg-success-100 text-success-600 border-success-500/30',
  warning: 'bg-warning-100 text-warning-500 border-warning-500/30',
  danger: 'bg-danger-100 text-danger-500 border-danger-500/30',
};

export interface AlertProps {
  tone?: Tone;
  title?: string;
  children: ReactNode;
  className?: string;
}

/**
 * Сообщение о состоянии.
 *
 * Ошибки и предупреждения объявляются немедленно (`role="alert"`):
 * сообщение «оплата не прошла» пользователь должен получить сразу,
 * а не когда доберётся до этого места страницы.
 */
export function Alert({ tone = 'info', title, children, className }: AlertProps) {
  const isUrgent = tone === 'danger' || tone === 'warning';

  return (
    <div
      role={isUrgent ? 'alert' : 'status'}
      className={cn('rounded-[var(--radius-control)] border px-4 py-3 text-sm', TONES[tone], className)}
    >
      {title && <p className="mb-0.5 font-semibold">{title}</p>}
      <div className="leading-relaxed">{children}</div>
    </div>
  );
}
